import { WorkoutsOverview } from "../../../common/components/workout/WorkoutsOverview/WorkoutsOverview";
import { endpointsMetadata } from "../../../common/infrastructure/routes/endpointsMetadata";
import { useHasActiveSubscription } from "../../../common/infrastructure/hooks/useHasActiveSubscription";

const INTRO = {
  storageKey: "myWorkoutsIntro",
  title: "Какво са „Моите тренировки“?",
  text:
    "Това е дневникът на вашите тренировки - всяка тренировка от групов клас, " +
    "лична тренировка с треньор или създадена от вас се записва тук. Докоснете " +
    "тренировка, за да видите упражненията, сериите, повторенията и тежестите, " +
    "а в „Статистика“ следете обема и прогреса си във времето.",
};

/**
 * Portal page with three tabs: the user's workout list ("Тренировки"), aggregated
 * training statistics ("Статистика") and personal-record badges ("Постижения").
 * Rendering lives in the reusable
 * WorkoutsOverview; this page feeds it the caller-scoped endpoints and enables the
 * subscribed-only "+" create-standalone-workout flow.
 */
export const MyWorkouts = () => {
  const canCreate = useHasActiveSubscription();

  return (
    <WorkoutsOverview
      listEndpoint={endpointsMetadata.workoutPlan.getMyWorkouts}
      listQueryKey={[endpointsMetadata.workoutPlan.getMyWorkouts]}
      statistics={{}}
      achievements={{}}
      dialogMode="owner"
      showCreateButton
      canCreate={canCreate}
      intro={INTRO}
    />
  );
};
